/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Flux_BlurbInputs */

const ja_home_brands_flux_blurb = /** @type {(inputs: Home_Brands_Flux_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツと競技ゲームは進化しています。FLUXは、変化を受け入れ、競技ゲームの新しい形を模索する日本発のeスポーツトーナメントブランドです。`)
};

const en_home_brands_flux_blurb = /** @type {(inputs: Home_Brands_Flux_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive Game Tournaments that focus on unique competitions and engaging entertainment.`)
};

/**
* | output |
* | --- |
* | "Competitive Game Tournaments that focus on unique competitions and engaging entertainment." |
*
* @param {Home_Brands_Flux_BlurbInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_flux_blurb = /** @type {((inputs?: Home_Brands_Flux_BlurbInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Flux_BlurbInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_flux_blurb(inputs)
	return en_home_brands_flux_blurb(inputs)
});